import { useRef, useEffect } from "react";
import { OUR_WORK_IMAGES } from "./OurWorkImages";
import "../../styles/VerticalOurWork.css";

export default function VerticalOurWork({ onImageClick = () => {} }) {
  const isRunningRef = useRef(true);

  return (
    <div className="ourwork-wrapper">
      {/* LEFT COLUMN → UP */}
      <Column
        images={OUR_WORK_IMAGES}
        direction="up"
        widthClass="ourwork-col-side"
        isRunningRef={isRunningRef}
        peekOnly
      />

      {/* MIDDLE COLUMN → DOWN */}
      <Column
        images={OUR_WORK_IMAGES}
        direction="down"
        widthClass="ourwork-col-main"
        isRunningRef={isRunningRef}
        onImageClick={onImageClick}
        peekOnly={false}
      />

      {/* RIGHT COLUMN → UP */}
      <Column
        images={OUR_WORK_IMAGES}
        direction="up"
        widthClass="ourwork-col-side"
        isRunningRef={isRunningRef}
        peekOnly
      />
    </div>
  );
}

function Column({
  images,
  direction,
  widthClass,
  isRunningRef,
  onImageClick = () => {},
  peekOnly,
}) {
  const trackRef = useRef(null);
  const y = useRef(0);

  useEffect(() => {
    const track = trackRef.current;
    const container = track.parentElement;

    let last = performance.now();
    const SPEED = 25;
    let raf;

    const animate = (now) => {
      if (!isRunningRef.current) return;

      const delta = (now - last) / 1000;
      last = now;

      const loopHeight = track.scrollHeight / 2;
      const dir = direction === "down" ? 1 : -1;

      y.current += dir * SPEED * delta;

      if (y.current <= -loopHeight) y.current += loopHeight;
      if (y.current >= 0) y.current -= loopHeight;

      track.style.transform = `translateY(${y.current}px)`;
      raf = requestAnimationFrame(animate);
    };

    const onWheel = (e) => {
      e.preventDefault();

      const loopHeight = track.scrollHeight / 2;
      y.current += e.deltaY * 0.6;

      if (y.current <= -loopHeight) y.current += loopHeight;
      if (y.current >= 0) y.current -= loopHeight;

      track.style.transform = `translateY(${y.current}px)`;
    };

    container.addEventListener("wheel", onWheel, { passive: false });
    raf = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(raf);
      container.removeEventListener("wheel", onWheel);
    };
  }, [direction, isRunningRef]);

  return (
    <div className={`ourwork-column ${widthClass}`}>
      <div ref={trackRef} className="ourwork-track">
        {[...images, ...images].map((src, index) => (
          <div
            key={index}
            className={`ourwork-item ${
              peekOnly ? "ourwork-item-peek" : "ourwork-item-main"
            }`}
            onPointerDown={() => {
              isRunningRef.current = false;
            }}
            onPointerUp={() => {
              if (!peekOnly) onImageClick(index % images.length);
            }}
          >
            <img src={src} alt="" draggable={false} />
          </div>
        ))}
      </div>
    </div>
  );
}
